<template>
  <div class="c-app">
    <TheSidebar/>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <CAlert v-if="warning" color="warning" closeButton :show="true" @update:show="clearWarning" class="email-warning">{{ warning }}</CAlert>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

import { mapState } from 'vuex'

export default {
  name: 'TheContainer',
  computed: {
    ...mapState({ warning: state => state.alert.warning }),
  },
  methods: {
    clearWarning(show) {
      if (!show) this.$store.dispatch('alert/warning', null);
    }
  },
  components: {
    TheSidebar,
    TheHeader,
    TheFooter
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
